<template>
  <v-card>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.validPenalities"
        hide-default-headers
        hide-default-footer
        disable-pagination
        disable-sort
      >
        <template v-slot:item.title="{item}">
          <span
            @click="()=>{englishTitle = !englishTitle;}"
          >{{ item[englishTitle?'englishTitle':'title'] }}</span>
        </template>
        <template v-slot:item.ctrl="{item}">
          <v-btn text v-if="item.totalAmount" @click="removePenality(item)">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-btn text v-else>
            <v-icon></v-icon>
          </v-btn>
          <span :class="'title '+(item.totalAmount > 0?'red--text':'')">{{ item.totalAmount }}</span>
          <v-btn text @click="addPenality(item)">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  VCard,
  VTooltip,
  VForm,
  VTextField,
  VCardActions,
  VCardText,
  VSelect,
  VDataTable,
  VDatePicker,
  VIcon
} from "vuetify/lib";
import fccapi from "../../fccapi.js";
import FCCRefereeApplication from "./FCCRefereeApplication.vue";
import TextDialog from "../../dialogs/TextDialog";
import ConfirmDialog from "../../dialogs/ConfirmDialog";

export default {
  name: "FCCRefereePenalities",
  data: () => ({
    races: [],
    race: null,
    starts: 0,
    penalities: [],
    englishTitle: false
  }),
  computed: {
    rules: function() {
      return {
        required: value => !!value || this.$t("registration.required")
      };
    },
    headers: function() {
      return [
        {
          text: this.$t("penalities.description"),
          value: "title",
          align: "left"
        },
        {
          text: this.$t("penalities.totalAdditionalTime"),
          value: "penalityString",
          align: "left"
        },
        { text: "", value: "ctrl", align: "left" }
      ];
    },
    run: function() {
      return this.runs[this.startId * 2 + (this.red ? 1 : 0)];
    },
    validPenalities: function() {
      if (!this.run) return [];
      return this.penalities
        .filter(p => p.applicationType == this.run.application.applicationType)
        .sort(function(a, b) {
          return a.disciplineId - b.disciplineId;
        })
        .map(val => {
          val.runPenalities = this.run.runPenalities.filter(
            p => p.penalityId == val.id
          );
          val.totalAmount = val.runPenalities.reduce(
            (acc, v) => acc + v.amount,
            0
          );
          return val;
        });
    }
  },
  components: {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
    FCCRefereeApplication,
    TextDialog,
    ConfirmDialog,
    VIcon
  },
  methods: {
    addPenality: function(penality) {
      if (penality.totalAmount > 0) {
        var r = penality.runPenalities[0];
        fccapi
          .post(`run-penalities/${r.id}`, {
            runId: this.run.id,
            penalityId: penality.id,
            amount: r.amount + 1
          })
          .then(d => {})
          .catch(e => {
            console.log(e);
          });
      } else {
        console.log("Create new");
        fccapi
          .post(`run-penalities`, {
            runId: this.run.id,
            penalityId: penality.id,
            amount: 1
          })
          .then(d => {})
          .catch(e => {
            console.log(e);
          });
      }
    },
    removePenality: function(penality) {
      if (penality.totalAmount > 1) {
        console.log("Decreasing");
        var r = penality.runPenalities[0];
        fccapi
          .post(`run-penalities/${r.id}`, {
            runId: this.run.id,
            penalityId: penality.id,
            amount: r.amount - 1
          })
          .then(d => {})
          .catch(e => {
            console.log(e);
          });
      } else {
        console.log("deleting");
        var r = penality.runPenalities[0];
        fccapi
          .delete(`run-penalities/${r.id}`)
          .then(d => {})
          .catch(e => {
            console.log(e);
          });
      }
      console.log("remove penality");
    }
  },
  mounted() {
    fccapi.competitionGet("penalities").then(r => {
      this.penalities = r.data;
    });
  },
  props: {
    runs: Array,
    startId: Number,
    red: Boolean
  },
  filters: {}
};
</script>